import { AppBar, Button, Divider, Toolbar, Typography } from '@mui/material';
import { Box, Container } from '@mui/system';
import { TimeSelector } from 'components';
import { useNavigate, useParams } from 'react-router';
import backV1 from 'assets/images/backV1.svg';

export const TimeSelectorPage: React.FC = () => {
  const navigate = useNavigate();
  const handleBackClick = () => {
    navigate(-1);
  };
  const { timeTypeParams } = useParams();

  const locationTitle =
    timeTypeParams === 'pickup-time' ? 'Pickup Time' : 'Return Time';

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          bgcolor: '#043d60',
          backdropFilter: 'blur(8px)',
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar>
          <Button onClick={handleBackClick}>
            <img src={backV1} alt="Back-btn" width={100} />
          </Button>
          <Typography className="navbarTitle" color="primary" component="p">
            {`CHOOSE YOUR `}
            <span style={{ textDecoration: 'underline', fontWeight: '600' }}>
              {locationTitle?.toLocaleUpperCase()}
            </span>
          </Typography>
        </Toolbar>
        <Divider sx={{ backgroundColor: 'lightgray', height: '1px' }} />
      </AppBar>
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginBottom: '20px',
          marginTop: '20px',
        }}
      >
        <TimeSelector fieldName={timeTypeParams} />
      </Container>
    </Box>
  );
};
